import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { components } from "react-select";

export const Storages = ({
  areaId,
  onChange,
  setStorages,
  setSelectedValues,
  selectedValues,
}) => {
  const { proxy, lang } = useSelector((s) => s);
  const [state, setState] = useState([]);
  const [options, setOptions] = useState([]);
  const isAll = useRef(false);

  const handleGetStorages = async (page = 0, loadedOptions, search = "") => {
    try {
      if (!areaId) {
        return {
          options: [],
          hasMore: false,
          additional: {
            page: 0,
          },
        };
      }
      const response = await fetch(
        `${proxy()}/area/warehouse?skip=${page}&search=${search}`,
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
            Authorization: localStorage.getItem("_token"),
          },
          body: JSON.stringify({ areaId }),
        }
      );
      const result = await response.json();

      let newData = {
        options: [],
        hasMore: false,
        additional: {
          page: 0,
        },
      };

      if (result.length) {
        newData.additional = { page: page + 15 };
        newData.hasMore = result.length ? true : false;

        newData.options = result.map((area) => ({
          ...area,
          label: [area["maKhoERPKho"], area["4TK"], area["8LK"]]
            .filter(Boolean)
            .join("|"),
          value: area?.["11MK"],
        }));
      }
      return newData;
    } catch (err) {
      console.log("OPTION ERROR:", err);
    }
  };
  const shouldLoadMore = (scrollH, clientH, scrollT) => {
    return scrollH === clientH + scrollT && !isAll.current;
  };
  useEffect(() => {
    setOptions([]);
  }, [areaId]);

  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };

  return (
    <div className="col-sm-7 mb-2">
      <label>Kho</label>
      <div className="d-flex align-items-center">
        <AsyncPaginate
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          placeholder={lang["select value"]}
          components={{
            Option: CustomOption,
          }}
          className="w-100"
          isMulti={true}
          key={areaId}
          // shouldLoadMore={shouldLoadMore}
          filterOption={() => !isAll.current}
          loadOptions={async (search, loadedOptions, { page }) => {
            const res = await handleGetStorages(page, loadedOptions, search);
            if (res.hasMore) {
              setOptions([...loadedOptions, ...res.options]);
            }
            return res;
          }}
          options={[{ label: "Tất cả", value: "all" }]}
          value={selectedValues?.storagesView || []}
          onChange={async (opts = []) => {
            const last = opts[opts.length - 1];
            const hasAll = opts.some((o) => o?.value === "all");

            let storages = [];

            if (hasAll) {
              const response = await fetch(
                `${proxy()}/area/warehouse?isAll=true`,
                {
                  method: "POST",
                  headers: {
                    "content-type": "application/json",
                    Authorization: localStorage.getItem("_token"),
                  },
                  body: JSON.stringify({ areaId }),
                }
              );
              const result = (await response.json()) || [];

              const mappedData = result.map((item) => {
                const labelParts = [
                  item?.maKhoERPKho,
                  item?.["4TK"],
                  item?.["8LK"],
                ].filter(Boolean);

                return {
                  ...item,
                  label: labelParts.length > 0 ? labelParts.join(" | ") : "",
                  value: item?.["11MK"],
                };
              });

              storages = mappedData;
              setStorages(storages);
              onChange(storages);
            } else {
              storages = opts.length ? opts : [];
              setStorages(storages);
              onChange(storages);
            }

            setSelectedValues((prev) => ({
              ...prev,
              storagesView: storages,
            }));
          }}
          isSearchable={true}
          // value={state}
          styles={{
            control: (base) => ({
              ...base,
              maxHeight: "10vh",
              overflow: "auto",
            }),
            menuList: (base) => ({
              ...base,
              maxHeight: 300,
              overflowY: "auto",
              fontFamily: "UTM Avo , sans-serif !important",
              zIndex: 99999,
            }),
            menu: (base) => ({
              ...base,
              zIndex: 99999,
            }),
          }}
          additional={{
            page: 0,
          }}
          allowCreateWhileLoading={false}
        />
        <div className="ml-3">
          <button
            className="btn btn-danger m-0"
            onClick={() => {
              setSelectedValues((prev) => ({
                ...prev,
                storagesView: [],
              }));
              setStorages([]);
            }}
          >
            Xóa
          </button>
        </div>
        {/* <a
          className="btn btn-success btn-custom add float-right m-0 ml-3"
          onClick={() => {
            let value = state?.value ? [state.value] : null;
            if (state.value === "all") {
              value = options
                .filter((option) => typeof option.value === "object")
                .map(({ value }) => value);
            }
            if (value) {
              onChange(value);
            }
          }}
        >
          <FontAwesomeIcon icon={faPlus} color="white" />
        </a> */}
      </div>
    </div>
  );
};
